import styled from 'styled-components';

export const Container = styled.main`
  min-height: 100vh;
  width: 100%;
  align-content: center;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const Title = styled.p`
  font-weight: 400;
  font-size: 36px;
  line-height: 44px;
  letter-spacing: 0px;
  text-align: center;
  margin-top: 32px;
`;

export const Subtitle = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.15px;
  text-align: center;
  margin-top: 16px;
  margin-bottom: 32px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;
